module.exports = require("plugin-liverig/shared/curves/api");